import React from "react";
import ReactMarkdown from "react-markdown";
import { resizeAndConvertImage } from "../../utils/common";
//// DEVELOPMENT
// import $ from 'jquery';
export class Speaker extends React.Component {
  openPopup(speakerId) {
    try {
      let modalRef = $(`.tint-speaker[modalId=${speakerId}]`);
      if (modalRef) {
        modalRef.fadeIn();
      }
    } catch (error) {}
  }

  render() {
    let { data: speaker } = this.props;
    return (
      <React.Fragment>
        <div
          class="speaker1"
          id={speaker.id}
          onClick={this.openPopup.bind(this, speaker.id)}
        >
          <img
            src={`${speaker.profilePicture.url}${resizeAndConvertImage(400)}`}
            alt={speaker.name}
            width="180"
            class="rounded-img"
          />
          <div class="sm-spacing" />
          <h6 class="h6">
            <strong>{speaker.name}</strong>
            <br />
          </h6>
          <div class="small-copy">{speaker.role}</div>
        </div>
      </React.Fragment>
    );
  }
}

export default Speaker;
